import { FC, useEffect, useState } from 'react';
import { TextLink } from '@bfe/moly';
import { getLocaleByUrl, openLink } from '@web3/base-utils';
import { scTrack } from '@web3/base-tracking';
import cls from 'classnames';
import styles from './index.module.scss';
import { useFm, useScreenType, useParams } from '@web3/base-hooks';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';

import 'swiper/css';
import { getCmsStarts } from '@/services/home';
import { LearnData } from '@/types/home';
import { Event, Page } from '@/config/track-config';
interface LearnContainerProps {}

export const cmsDeduplication = (arr: any[]) => {
  const tmp = new Map();
  const lang = getLocaleByUrl().toLowerCase();

  arr.forEach((item) => {
    const { pid } = item;

    if (pid) {
      if (tmp.has(pid)) {
        tmp.set(pid, item.locale === lang ? item : tmp.get(pid));
      } else {
        tmp.set(pid, item);
      }
    }
  });

  return [...tmp.values()];
};

export const LearnContainer: FC<LearnContainerProps> = () => {
  const fm = useFm();
  const { isMobile } = useScreenType();
  const { locale } = useParams();
  const [mainSwiper, setMainSwiper] = useState<SwiperClass>();
  const [dict, setDict] = useState<'prev' | 'next'>('prev');
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setisBeginning] = useState(true);
  const [list, setList] = useState<LearnData[]>([]);

  useEffect(() => {
    getCmsStarts().then((res) => {
      const { result } = res;
      setList(cmsDeduplication(result || []));
    });
  }, []);

  // const lists = Array.from({ length: 10 }).map(() => {
  //   return {
  //     title: 'Ethereum Name Server (ENS): Your Web3 Username',
  //     summary:
  //       'Currently, the Ethereum blockchain’s most pressing problems are its limited accessibility and scalability, which make it harder to use and lead to high gas fees per transaction.',
  //     link: 'https://www.google.com',
  //   };
  // });

  const onSwiperNext = () => {
    setDict('next');
    if (!mainSwiper?.isEnd) {
      // 检查是否已经到达最后一页
      mainSwiper?.slideNext();
    } else {
      // console.log('已经到达最后一页');
    }
  };

  const onSwiperPrev = () => {
    setDict('prev');
    if (!mainSwiper?.isBeginning) {
      // 检查是否已经到达第一页
      mainSwiper?.slidePrev();
    } else {
      // console.log('已经到达第一页');
    }
  };

  const navTo = (pid: string) => {
    scTrack(Event.Web3UserClick, {
      page_name: Page.Home,
      area: 'LearnWeb3',
      button_name: 'Learn',
      params: pid,
    });
    if (isMobile) {
      openLink(`/${locale}/web3/raiders/${pid}`);
      return;
    }
    window.open(`/${locale}/web3/raiders/${pid}`);
  };

  if (!list.length) {
    return null;
  }

  const swiperOptions = {
    slidesPerView: isMobile ? 'auto' : 3,
    slidesPerGroup: isMobile ? 1 : 3,
    spaceBetween: isMobile ? 20 : 24,
  };

  const displayPagination = isMobile ? list.length > 1 : list.length > 3;

  return (
    <div className={styles.learnBox}>
      <div className={styles.header}>
        <div className={styles.title}>{fm('learnWeb3')}</div>
        <div className={styles.sub}>{fm('learnFastWeb3')}</div>
      </div>

      <div className={styles.body}>
        {displayPagination ? (
          <div
            className={cls('swper-custom-prev', {
              'swper-custom-disable': dict === 'prev' && isBeginning,
            })}
            onClick={onSwiperPrev}
          ></div>
        ) : null}
        {displayPagination ? (
          <div
            className={cls('swper-custom-next', {
              'swper-custom-disable': dict === 'next' && isEnd,
            })}
            onClick={onSwiperNext}
          ></div>
        ) : null}
        <Swiper
          onSwiper={setMainSwiper}
          onSlideChange={(swiper) => {
            setIsEnd(swiper.isEnd);
            setisBeginning(swiper.isBeginning);
          }}
          slidesPerView={swiperOptions.slidesPerView}
          slidesPerGroup={swiperOptions.slidesPerGroup}
          spaceBetween={swiperOptions.spaceBetween}
          className="mySwiper"
        >
          {list.map((item, index) => (
            <SwiperSlide key={index} className={styles.customSwiperSlider}>
              <div
                className={styles.card}
                onClick={() => {
                  navTo(item.pid);
                }}
              >
                <div className={styles.t1}>{item.title}</div>
                <div className={styles.t2}>{item.summary}</div>
                <div className={styles.t3}>
                  <TextLink variant="primary" size="normal">
                    {fm('moreInfo')}
                  </TextLink>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
